module.exports = __webpack_public_path__ + "static/assets/a438423d2f2de1cfbd858e95033c630f.svg";